import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action} from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, {FormBody, FormActions, TextInput} from '../Form';
import * as api from '../../actions/api';

@inject('inventoryItemStore')
@observer
class ItemMovementAdd extends Component {
  static propTypes = {
    route: PropTypes.object.isRequired,
    // stationInventoryStore: PropTypes.object.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  }

  @observable movement = {
    id: this.props.params.itemId,
    remarks: ''
  };

  slug;
  title = 'Add Item Movement';

  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
    this.slug = `/station/${props.params.id}/inventory`;

  }

  // componentWillMount() {
  // this.slug = `/station/${this.props.params.id}/inventory`;
  // console.log('this.slug', this.slug);
  // }


  @action onChangeRemarks = e => this.movement.remarks = e.target.value;


  handleSave(e) {
    e.preventDefault();

    const {params: {id}} = this.props;
    const {notify} = this.context;
    let jsonBody = {
      stationId : id,
      remarks: this.movement.remarks
    };
    api.inventoryItem.movement
      .add(this.movement.id, jsonBody)
      .then(() => {
        notify.success();
        this.context.router.push(this.slug);
      })
      .catch(err => {
        notify.error(err);
        this.context.router.push(this.slug);
      })

  }

  render() {
    // const { stationInventoryStore } = this.props;

    // if (stationInventoryStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug}>
        <Form>
          <FormBody>
            <TextInput
              label={'Item'}
              value={this.movement.id}
              readOnly={true}
            />
            <TextInput
              label={'Remarks'}
              value={this.movement.remarks}
              onChange={this.onChangeRemarks}
            />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default ItemMovementAdd;



// WEBPACK FOOTER //
// ./src/components/Inventory/ItemMovementAdd.js